module.exports = __webpack_public_path__ + "static/media/a2.225fdb69.jpg";